import { render, staticRenderFns } from "./ComboMunicipio.vue?vue&type=template&id=254c2080&scoped=true"
import script from "./ComboMunicipio.vue?vue&type=script&lang=js"
export * from "./ComboMunicipio.vue?vue&type=script&lang=js"
import style0 from "./ComboMunicipio.vue?vue&type=style&index=0&id=254c2080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254c2080",
  null
  
)

export default component.exports